import { api } from "@/lib/axios";

export default function updateNegotiation({
  leadId,
  negotiation,
}: {
  leadId: string;
  negotiation: boolean;
}) {
  return api.put(`leads/negotiation/${leadId}`, {
    negotiation,
  });
}
